export default "__VITE_ASSET__DnBrK05H__"